module.exports = "<p>\n  list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/list.component.html
// module id = ./src/app/views/provider/list.component.html
// module chunks = main